// Turning a reader's selection into offsets a server can store, and back.
//
// Offsets count characters across the chapter container's text nodes in
// document order, with nothing added for block boundaries. That is exactly
// what Range.toString() measures, so the two directions agree.

const MARK = 'read-hl';

function textNodes(root) {
    const out = [];
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let pos = 0;
    for (let n = walker.nextNode(); n; n = walker.nextNode()) {
        const len = n.data.length;
        out.push({ node: n, start: pos, end: pos + len });
        pos += len;
    }
    return out;
}

/** The selection as {start, end, text} relative to root, or null if it isn't inside root. */
export function selectionOffsets(root) {
    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return null;
    const range = sel.getRangeAt(0);
    if (!root.contains(range.startContainer) || !root.contains(range.endContainer)) return null;
    const pre = document.createRange();
    pre.selectNodeContents(root);
    pre.setEnd(range.startContainer, range.startOffset);
    const start = pre.toString().length;
    const text = range.toString();
    if (!text.trim()) return null;
    return { start, end: start + text.length, text, rect: range.getBoundingClientRect() };
}

function locate(full, hl) {
    if (full.slice(hl.start, hl.end) === hl.text) return [hl.start, hl.end];
    // the author edited around it: fall back to the first place the text still occurs
    const i = full.indexOf(hl.text);
    return i >= 0 ? [i, i + hl.text.length] : null;
}

/** Wrap each highlight's text in <mark data-hl-id> elements inside root. */
export function applyHighlights(root, highlights) {
    for (const hl of highlights) {
        const nodes = textNodes(root);
        const full = nodes.map(n => n.node.data).join('');
        const span = locate(full, hl);
        if (!span) continue;
        const [s, e] = span;
        for (const { node, start, end } of nodes) {
            if (end <= s || start >= e) continue;
            const from = Math.max(s, start) - start;
            const to = Math.min(e, end) - start;
            let target = node;
            if (to < node.data.length) target.splitText(to);
            if (from > 0) target = target.splitText(from);
            const mark = document.createElement('mark');
            mark.className = MARK;
            mark.dataset.hlId = String(hl.id);
            target.parentNode.insertBefore(mark, target);
            mark.appendChild(target);
        }
    }
}

export function markFor(root, id) {
    return root.querySelector(`mark.${MARK}[data-hl-id="${id}"]`);
}
